import { escapeSql } from '@rdrive/helper-sql';
import { timeUnitOf, truncSql, timeKeySql } from '@rdrive/plugin-chart-time-series';
import { queryRows } from '@rdrive/data-duckdb';

// The status titles that actually have activity in a set of time buckets, used to
// label an exported PNG's legend. Both StatusHistory time-series configs
// (velocity and burndown) carried a byte-identical copy of this; it names tables,
// so by rule 2 it stays app-side — it just stopped being duplicated.
//
// Rows: { color, title } (column casing varies by source, so both spellings are
// normalised here). An empty bucket list short-circuits to `[]` without a query.
//
//   const fetchLegendTitles = makeFetchLegendTitles(conn);
//   await fetchLegendTitles(['2026-01', '2026-02'], 'month');
export const makeFetchLegendTitles = (conn) => async (timeKeys, groupBy) => {
  if (!timeKeys || timeKeys.length === 0) return [];

  const timeUnit = timeUnitOf(groupBy);
  // ISO-year week keys (`{ isoYear: true }`, 2026-10-07): the series configs below use the same,
  // so the legend's keys match the chart's across a year boundary
  const bucketKeySql = timeKeySql(timeUnit, truncSql(timeUnit, 'validFrom'), { isoYear: true });
  const timeKeysStr = timeKeys.map((k) => `'${escapeSql(k)}'`).join(',');

  const rows = await queryRows(conn, `
    SELECT DISTINCT st.color, st.title
    FROM filteredStatusHistory fsh
    JOIN status_templates st ON fsh.statusId = st.id
    WHERE ${bucketKeySql} IN (${timeKeysStr})
    ORDER BY st.sort
  `);

  return rows.map((row) => ({ color: row.Color || row.color, title: row.Title || row.title }));
};
